var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 100,
    viewBox: "0 0 77 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2857 80L55.7143 61.0714L76.0714 17.8571C75 13.2143 73.2143 9.64286 70.3571 7.14286C65.7143 2.14286 58.5714 0 48.5714 0H2.85714V20H42.8571C48.5714 20 51.4286 22.8571 51.4286 28.5714V35.7143L0 72.8571V100H37.5L46.7857 80H29.2857Z",
    fill: "url(#paint0_linear_17_3403)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_3403",
    x1: -37.0435,
    y1: 2.20038e-7,
    x2: -1.59251,
    y2: 112.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#53F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53F5FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.39205970a52b7e66b5ffe419af7071c6.svg";
export { ForwardRef as ReactComponent };